import "./BookYourPickup.module.css";
import Header from "@/reusable_sections/Header";
import ReachOurTeam from "./sections/ReachOurTeam";
import Footer from "@/reusable_sections/Footer";
export default function BookYourPickupPage() {
  return <div>
      <Header />
      <ReachOurTeam />
      <Footer />
    </div>;
}